import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { pisCofinsCstOptions } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.const';
import { InvoiceItemFormValues } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { Card, Col, Form, FormInstance, Row, Select, Space } from 'antd';

interface NoteItemsCofinsTabsFormProps {
  form: FormInstance<InvoiceItemFormValues>;
}

export default function NoteItemsCofinsTabsForm({
  form,
}: NoteItemsCofinsTabsFormProps) {
  return (
    <Form form={form}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Card title="COFINS" type="inner" style={{ marginBottom: 24 }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={8} lg={24}>
              <FloatingFormItem label="CST" name={['itemTaxes', 'cofinsCst']}>
                <Select allowClear options={pisCofinsCstOptions} />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Alíquota"
                name={['itemTaxes', 'cofinsAliquot']}
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Valor"
                name={['itemTaxes', 'cofinsValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Base de cálculo"
                name={['itemTaxes', 'cofinsBaseCalculationValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Quantidade vendida"
                name={['itemTaxes', 'cofinsSoldQuantity']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Alíquota em reais"
                name={['itemTaxes', 'cofinsRealAliquot']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Card>

        <Card title="COFINS ST" type="inner">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Alíquota"
                name={['itemTaxes', 'cofinsStAliquot']}
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Valor"
                name={['itemTaxes', 'cofinsStValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Base de cálculo"
                name={['itemTaxes', 'cofinsStBaseCalculation']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Quantidade vendida"
                name={['itemTaxes', 'cofinsStSoldQuantity']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={8} lg={6}>
              <FloatingFormItem
                label="Alíquota em reais"
                name={['itemTaxes', 'cofinsStRealAliquot']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </Card>
      </Space>
    </Form>
  );
}
